module.exports = __webpack_public_path__ + "img/write.6239c3d7.png";